import { formatFileSize, isDefinedGlobally } from './utils';

const messages = {
  _default: () => `No es válido.`,
  after: (field, [target, inclusion]) => `Debe ser posterior ${inclusion ? 'o igual ' : ''}a ${target}.`,
  alpha_dash: () => `Solo debe contener letras, números y guiones.`,
  alpha_num: () => `Solo debe contener letras y números.`,
  alpha_spaces: () => `Solo debe contener letras y espacios.`,
  alpha: () => `Solo debe contener letras.`,
  before: (field, [target, inclusion]) => `Debe ser anterior ${inclusion ? 'o igual ' : ''}a ${target}.`,
  between: (field, [min, max]) => `Debe estar entre ${min} y ${max}.`,
  confirmed: () => `No coincide.`,
  credit_card: () => `Es inválido.`,
  date_between: (field, [min, max]) => `Debe estar entre ${min} y ${max}.`,
  date_format: (field, [format]) => `Debe tener formato formato ${format}.`,
  decimal: (field, [decimals = '*'] = []) => `Debe ser númerico y contener ${decimals === '*' ? '' : decimals} puntos decimales.`,
  digits: (field, [length]) => `Debe ser númerico y contener exactamente ${length} dígitos.`,
  dimensions: (field, [width, height]) => `Debe ser de ${width} pixeles por ${height} pixeles.`,
  email: () => `Debe ser un correo electrónico válido.`,
  ext: () => `Debe ser un archivo válido.`,
  image: () => `Debe ser una imagen.`,
  included: () => `Debe ser un valor válido.`,
  integer: () => `Debe ser un entero.`,
  ip: () => `Debe ser una dirección ip válida.`,
  length: (field, [length, max]) => {
    if (max) {
      return `El largo debe estar entre ${length} y ${max}.`;
    }
    return `El largo debe ser ${length}.`;
  },
  max: (field, [length]) => `No debe ser mayor a ${length} caracteres.`,
  max_value: (field, [max]) => `Debe de ser ${max} o menor.`,
  mimes: () => `Debe ser un tipo de archivo válido.`,
  min: (field, [length]) => `Debe tener al menos ${length} caracteres.`,
  min_value: (field, [min]) => `Debe ser ${min} o superior.`,
  excluded: () => `Debe ser un valor válido.`,
  numeric: () => `Debe contener solo caracteres númericos.`,
  regex: () => `El formato no es válido.`,
  required: () => `Es obligatorio.`,
  size: (field, [size]) => `Debe ser menor a ${formatFileSize(size)}.`,
  url: () => `No es una URL válida.`
};

const locale = {
  name: 'es',
  messages,
  attributes: {}
};

if (isDefinedGlobally()) {
  // eslint-disable-next-line
  VeeValidate.Validator.localize({ [locale.name]: locale });
}

export default locale;